import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@mui/material';
import { AdminMessageDto } from '../../../../../generated-types/adminMessageDto';

/**
 * The properties for the message dialog
 */
interface MessageDialogProps {
  dialogOpen: boolean;
  handleCloseDialog: () => void;
  selectedMessage: AdminMessageDto | null;
  messageStates: string[];
}

/**
 * A dialog to show the clicked message
 */
const MessageDialog = (props: MessageDialogProps) => {
  return (
    <Dialog
      open={props.dialogOpen}
      onClose={props.handleCloseDialog}
      fullWidth
      maxWidth="sm"
    >
      <DialogTitle>Message Details</DialogTitle>
      <DialogContent dividers>
        {props.selectedMessage && (
          <>
            <Typography variant="subtitle1">
              <strong>From:</strong> {props.selectedMessage.from}
            </Typography>
            <Typography variant="body1" sx={{ my: 2 }}>
              {props.selectedMessage.message}
            </Typography>
            <Divider />
            <Typography variant="subtitle2" sx={{ mt: 2 }}>
              <strong>Received:</strong>{' '}
              {new Date(props.selectedMessage.received).toLocaleString()}
            </Typography>
            <Typography variant="subtitle2">
              <strong>State:</strong>{' '}
              {props.messageStates[props.selectedMessage.state]}
            </Typography>
            <Typography variant="subtitle2">
              <strong>State Last Changed By:</strong>{' '}
              {props.selectedMessage.lastChangedBy}
            </Typography>
            <Typography variant="subtitle2">
              <strong>Source:</strong> {props.selectedMessage.source}
            </Typography>
          </>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={props.handleCloseDialog} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageDialog;
